import { atom } from 'jotai'
import { CustomerActionSheet } from 'types/atoms/atom.customers'
import { BusinessCustomerType, CustomerWallet, IndividualCustomerType } from 'types/customers'
import { CustomerModel } from '../helpers/types'

export const customerModelAtom = atom<CustomerModel>()
customerModelAtom.debugLabel = 'customer-model'

export const currentCustomerAtom = atom<BusinessCustomerType | IndividualCustomerType>()
currentCustomerAtom.debugLabel = 'current-customer'

export const currentCustomerWalletAtom = atom<CustomerWallet>()
currentCustomerWalletAtom.debugLabel = 'current-customer-wallet'

export const customerActionAtom = atom<CustomerActionSheet>({} as CustomerActionSheet)
customerActionAtom.debugLabel = 'customer-action'
